import classNames from "classnames";

import {Card} from "@/components/card/Card.tsx";
import {Divider} from "@/components/divider/Divider.tsx";
import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {SwitchField} from "@/components/form/fields/SwitchField.tsx";
import {TextAreaField} from "@/components/form/fields/TextAreaField.tsx";
import {PropsWithClassName} from "@/lib/types/props.ts";

export const SSOSetupStep2V2 = ({className}: PropsWithClassName) => (
  <div className={classNames(className, "d-flex flex-column gap-4")}>
    <div className={"d-flex flex-column gap-2"}>
      <div className="pulseTextBodyBold">Identity Provider Details</div>
      <span className="pulseTextBodySmall pulse-color-gray-600">
        Enter the login details and certificate from your identity provider.
      </span>
    </div>
    <InputField
      label="Entity ID / Issuer"
      name="idp_entity_id"
      helpText="The unique identifier of your identity provider."
    />
    <InputField
      label="SSO Target URL"
      name="idp_sso_target_url"
      helpText="The URL used to trigger a login with your identity provider (HTTP-Redirect method)."
    />
    <TextAreaField
      label="Identity Provider's Certificate"
      name="idp_certificate"
      helpText="A valid X.509 certificate in PEM format used for signing by the identity provider."
      rows={6}
      cols={40}
    />

    <Divider className={"my-2"} />

    <div className="pulseTextBodyBold">Signing Options</div>
    <Card variant="white" className={"p-3"}>
      <div className="d-flex flex-column gap-3">
        <SwitchField
          name="use_sha1_for_signature"
          labelPosition={"left"}
          label={"Use legacy SHA-1 for signing instead of the recommended SHA-256"}
          description={"Enable only if your identity provider doesn't support SHA-256."}
        />
        <Divider />
        <SwitchField
          name="unsigned_authn_requests"
          labelPosition={"left"}
          label={"Don't digitally sign SAML AuthN requests"}
          description={"Required for Azure. Enable if SAML login fails via the Uptime.com form."}
        />
      </div>
    </Card>
  </div>
);
